<template>
  <div class="formField textField" :class="{ hasFocus, hasValue, isError, isDisabled, isInline, isGrid, hasPlaceholder }">
    <FormLabel v-bind="formLabelProps">
      <slot name="tooltip" />
    </FormLabel>
    <slot />
    <div class="textField__Wrapper">
      <div class="textField__Prepend" v-if="$slots['prepend']">
        <slot name="prepend" />
      </div>
      <input
        :id="uniqueID"
        :name="name"
        :type="type"
        :disabled="isDisabled"
        :required="isRequired"
        :min="min"
        :max="max"
        :minlength="minlength"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :inputmode="inputmode"
        @focus="setFocus(true)"
        @blur="setBlur"
        v-model="fieldValue"
      />
      <div class="textField__Append" v-if="$slots['append']">
        <slot name="append" />
      </div>
    </div>
    <FormError :errors="mergedErrors" className="textField__Error" />
    <span class="textField__Info form__Info" v-html="info" v-if="info" />
  </div>
</template>

<script setup>
  const emit = defineEmits(['update:modelValue', 'focus', 'blur'])
  const props = defineProps({
    ...useFormFieldProps(),
    placeholder: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: 'text'
    },
    minlength: {
      type: [String, Number]
    },
    maxlength: {
      type: [String, Number]
    },
    min: {
      type: [String, Number]
    },
    max: {
      type: [String, Number]
    },
    inputmode: {
      type: String,
      default: null
    },
  })

  const {
    isError,
    isDisabled,
    isRequired,
    isInline,
    isGrid,
    hasValue,
    fieldValue,
    mergedErrors,
    uniqueID,
    formLabelProps,
    hasFocus,
    setFocus,
    triggerValidate
  } = useFormField(props, emit)

  const hasPlaceholder = computed(() => props.placeholder)

  function setBlur() {
    setFocus(false)
    emit('blur', fieldValue.value);
  }

  watch(() => hasFocus.value, (value) => {
    if (value) {
      emit('focus')
    }
  })

  defineExpose({
    triggerValidate,
    mergedErrors,
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_textField.scss');
</style>
